import rill from "rill";
import set from "@rill/set";
import servicesController from "./services.controller.js";

const Services = (app) => {
  app.at(
    "/services/*",
    rill()
      .use(set("heading", ["Coaching", "Our Services"]))
      .setup((app) => {
        app.get("/", servicesController);
      })
  );
};

export default Services;
